export default {
    list: [
        {
            color: "accent",
            date: "1st September 2009",
            title: "components.about.list.0.title",
            titleColor: 'accent',
            description:
                "components.about.list.0.description"
        },
        {
            color: "accent",
            date: "9th April 2017",
            title: "components.about.list.1.title",
            titleColor: 'accent',
            description:
                "components.about.list.1.description"
        },
        {
            color: "accent",
            date: "10th May 2017",
            title: "components.about.list.2.title",
            titleColor: 'accent',
            description:
                "components.about.list.2.description",
        },
        {
            color: "accent",
            date: "1st July 2017",
            title: "components.about.list.3.title",
            titleColor: 'accent',
            description:
                "components.about.list.3.description",
        },
        {
            color: "accent",
            date: "21st December 2017",
            title: "components.about.list.4.title",
            titleColor: 'accent',
            description:
                "components.about.list.4.description",
        },
        {
            color: "accent",
            date: "27th December 2017",
            title: "components.about.list.5.title",
            titleColor: 'accent',
            description:
                "components.about.list.5.description",
        },
        {
            color: "accent",
            date: "9th April 2018",
            title: "components.about.list.6.title",
            titleColor: 'accent',
            description:
                "components.about.list.6.description",
        },
        {
            color: "accent",
            date: "1st March 2018",
            title: "components.about.list.7.title",
            titleColor: 'accent',
            description:
                "components.about.list.7.description",
        },
        {
            color: "accent",
            date: "9th April 2019",
            title: "components.about.list.8.title",
            titleColor: 'accent',
            description:
                "components.about.list.8.description",
        },
        {
            color: "accent",
            date: "16th August 2019",
            title: "components.about.list.9.title",
            titleColor: 'accent',
            description:
                "components.about.list.9.description",
        },
        {
            color: "accent",
            date: "9th April 2020",
            title: "components.about.list.10.title",
            titleColor: 'accent',
            description:
                "components.about.list.10.description",
        },
        {
            color: "accent",
            date: "1st September 2019",
            title: "components.about.list.11.title",
            titleColor: 'accent',
            description:
                "components.about.list.11.description",
        },
        {
            color: "accent",
            date: "30th December 2020",
            title: "components.about.list.12.title",
            titleColor: 'accent',

            description:
                "components.about.list.12.description",
        },
        {
            color: "accent",
            date: "9th April 2021",
            title: "components.about.list.13.title",
            titleColor: 'accent',
            description:
                "components.about.list.13.description",
        },
        {
            color: "accent",
            date: "6th April 2021",
            title: "components.about.list.14.title",
            titleColor: 'accent',
            description:
                "components.about.list.14.description",
        },
        {
            color: "accent",
            date: "9th April 2022",
            title: "components.about.list.15.title",
            titleColor: 'accent',
            description:
                "components.about.list.15.description",
        },
        {
            color: "accent",
            date: "5th November 2023",
            title: "components.about.list.16.title",
            titleColor: 'accent',
            description:
                "components.about.list.16.description",
        },
        {
            color: "accent",
            date: "9th April 2023",
            title: "components.about.list.17.title",
            titleColor: 'accent',
            description:
                "components.about.list.17.description",
        },
        {
            color: "accent",
            date: "9th April 2024",
            title: "components.about.list.18.title",
            titleColor: 'accent',
            description:
                "components.about.list.18.description",
        },
        {
            color: "accent",
            date: "20th March 2024",
            title: "components.about.list.19.title",
            titleColor: 'accent',
            description:
                "components.about.list.19.description",
        },
    ]
}
